import { createSelector, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { regionalPostsExtraReducers } from '@store/reducres/regionalPost.reducers'

export interface RegionalImg {
  author: string
  url: string
}

export interface RegionalTag {
  id: string
  label: string
  slug: string
  postRelation: string
}

export interface RegionalPost {
  author: string
  description: string
  img: RegionalImg
  link: string
  postId: string
  publishTime: string
  tags: [RegionalTag]
  title: string
}

export interface RegionalPostsState {
  posts: RegionalPost[]
  loading: boolean
  error: string | null
}

const initialState: RegionalPostsState = {
  posts: [],
  loading: false,
  error: null,
}

const regionalPostSlice = createSlice({
  name: 'regionalPosts',
  initialState,
  reducers: {},
  extraReducers: regionalPostsExtraReducers,
})

export default regionalPostSlice.reducer

export const selectRegionalPosts = (state: RootState) => state.posts

export const selectRegionalPostsLoading = createSelector(
  [selectRegionalPosts],
  (postsState) => postsState.loading
)
export const selectAllRegionalPosts = createSelector(
  [selectRegionalPosts],
  (postsState) => postsState.posts
)
